@if (editMode && sortLoading) {
    <div class="sorting-loading">
        <div class="fancy-loader"></div>
        <div class="sort-message">
            <div class="title">{{ sortMessage }}</div>
            @if (config.sortMessageSubtitle) {
                <div class="sub-title">
                    {{ config.sortMessageSubtitle }}
                </div>
            }
        </div>
    </div>
}
<div class="detail-page-card">
    <div class="detail-page-card-title">{{ name }}</div>
    <div class="detail-page-card-actions">
        @if (!config.disableSort) {
            <button class="btn btn-raised" (click)="toggleSortMode()">
                <i class="fas fa-sort me-2"></i>{{
                    (editMode
                        ? "listView.completeOrderButton"
                        : "listView.changeOrderButton"
                    ) | t
                }}
            </button>
            <div class="spacer"></div>
        }
        <button
            type="button"
            class="btn btn-raised export-button"
            (click)="exportClick()"
            [disabled]="isGeneratingExport"
            title="{{ 'listView.exportTitle' | t }}"
        >
            @if (isGeneratingExport) {
                <i class="fas fa-circle-notch fa-spin"></i>
            } @else {
                <i class="fas fa-file-excel" aria-hidden="true"></i>
            }
        </button>
        @if (!editMode && !config.disableAdd) {
            <button class="btn btn-raised green" (click)="addClick(null)">
                <i class="fas fa-plus me-2"></i>{{ "listView.addButton" | t }}
            </button>
        }
    </div>
    @if (!editMode) {
        <div class="detail-page-card-actions search-actions">
            <input
                type="text"
                placeholder="{{ 'listView.searchPlaceholder' | t }}"
                class="form-control form-control-sm"
                [(ngModel)]="searchFilter"
                inputTooltip
            />

            <button class="btn btn-outline-secondary btn-sm search-button" (click)="search()">
                <i class="fas fa-search"></i>
            </button>
            <button
                class="btn btn-outline-secondary btn-sm search-reset-button"
                (click)="resetSearchFilter()"
            >
                <i class="fas fa-times"></i>
            </button>
        </div>
    }
    <div class="detail-page-card-body">
        @if (dataLoading) {
            <div class="fancy-loader submodule"></div>
        } @else {
            @for (item of editMode ? data : searchedData; track item) {
                <div
                    class="item"
                    (click)="itemClick(item)"
                    [class.selected]="selected && selected === item.ID"
                    [class.dropzone]="editMode && item.highlight"
                    [class.dropabove]="editMode && dropAbove"
                    [class.dropbelow]="editMode && dropBelow"
                    [class.moving]="editMode && item.show === false"
                    [class.just-moved]="editMode && item.newlocation"
                    [class.selected]="!editMode && item.ID === selected"
                    [class.filterhighlight]="!editMode && item.highlight"
                    [class.filterhide]="!editMode && item.show === false"
                    [draggable]="editMode"
                    (dragstart)="dragStart(item, $event)"
                    (dragend)="dragStop(item, $event)"
                    (dragover)="dragOver($event)"
                    (drop)="dragDrop(item, $event)"
                    (dragenter)="dragEnter(item)"
                >
                    {{ item.Name }}
                </div>
            }
        }
    </div>
</div>
